export function isBlank(value) {
  return value === undefined || value === null || String(value).trim() === "";
}

export function isEmail(value) {
  if (isBlank(value)) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
}

export function isPositiveInt(value) {
  const num = Number(value);
  return Number.isInteger(num) && num > 0;
}

export function isValidDate(value) {
  if (isBlank(value)) return false;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(value))) return false;
  const date = new Date(`${value}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return false;
  const [y, m, d] = String(value).split("-").map(Number);
  return (
    date.getUTCFullYear() === y &&
    date.getUTCMonth() + 1 === m &&
    date.getUTCDate() === d
  );
}

export function isPhone(value) {
  if (isBlank(value)) return false;
  const digits = String(value).replace(/\D/g, "");
  return digits.length >= 8;
}

export function buildErrorHtml(errors) {
  return `<ul class="text-start mb-0">${errors
    .map((err) => `<li>${err}</li>`)
    .join("")}</ul>`;
}
